import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem, RequirementContextType } from "../../../../types";
import { WSPillProps } from "@wingspanhq/fe-component-library";
import { IBackgroundCheckRequestResponse } from "@wingspanhq/background-checks/dist/lib/interfaces";
import { getBackgroundCheckRequirementStatus } from "./getBackgroundCheckRequirementStatus";

export const getBackgroundCheckPayeeRequirementStatus = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  backgroundChecksRequest: IBackgroundCheckRequestResponse | undefined
): { pill: WSPillProps; secondaryText?: string } => {
  return getBackgroundCheckRequirementStatus(
    requirement,
    contextItem,
    backgroundChecksRequest,
    RequirementContextType.Payer
  );
};
